import {
  TicketsContainer,
  TicketsInnerContainer,
} from './styles/Tickets.styled';
import { MyTickets } from 'src/components/Tickets/MyTickets';
import { ServiceDeskProvider } from 'src/context/ServiceDesk/ServiceDeskContext';

export const ServiceDesk = () => {
  return (
    <ServiceDeskProvider>
      <TicketsContainer>
        <TicketsInnerContainer>
          <MyTickets />
        </TicketsInnerContainer>
      </TicketsContainer>
    </ServiceDeskProvider>
  );
};
